/**
 * @file 获取资源列表
 * @author liudy
 */
import Api from '../../path';
import { HomeworkSubmitStatus } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export enum homeworkSessionTypeEnum {
    VIDEO = '11',
    DOCUMENTS = '14',
    IMAGE_ARTICLE = '15',
}

export enum EVideoSource {
    RECORD = 2,
    UPLOAD = 1,
}
export interface ISaveHomeworkInput {
    parent_id: number;
    homework_id?: number;
    homework_data: string; // {type: homeworkSessionTypeEnum; title: string }
    submit_status: HomeworkSubmitStatus;
    video_source?: EVideoSource;
}

export interface ISaveHomeworkOutput {
    homework_id: number;
}

export const saveHomework = fetchDataSync((data: ISaveHomeworkInput): Promise<IResponse<ISaveHomeworkOutput>> => {
    return fetchData(Api.HOMEWORK_SAVE, data).then((res: IResponse<ISaveHomeworkOutput>) => {
        return res;
    });
});

export const saveHomeworkPromise = (data: ISaveHomeworkInput): Promise<IResponse<ISaveHomeworkOutput>> => {
    return fetchData(Api.HOMEWORK_SAVE, data).then((res: IResponse<ISaveHomeworkOutput>) => {
        return res;
    });
};